<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form action="" method="post" class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-3"></div>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-3"></div>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-webp"></div>
                    <span v-if="allerrors.image_webp" :class="['show-error']">{{
                        allerrors.image_webp[0]
                    }}</span>
                    <a
                        v-if="image_webp_path"
                        :href="image_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Color de fondo banner</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="color"
                        laceholder="Seleccione un color"
                        label="name"
                        track-by="id"
                        :options="arrayColors"
                    ></multiselect>
                    <span v-if="allerrors.color_id" :class="['show-error']">{{
                        allerrors.color_id[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-webp"
            text_button="Imagen webp"
        ></template-uploader>
    </div>
</template>

<script>
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            title: null,
            image: null,
            image_webp: null,
            text_image_alt: null,
            image_path: null,
            image_webp_path: null,
            color: null,
            arrayColors: [],
            allerrors: {
                title: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
                color_id: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/sections?section=privacidad")
                .then(function (response) {
                    me.title = response.data.title;
                    me.image = response.data.image;
                    me.image_webp = response.data.image_webp;
                    me.image_path = response.data.image_path;
                    me.image_webp_path = response.data.image_webp_path;
                    me.color = response.data.color;
                    me.text_image_alt = response.data.text_image_alt;
                    me.clearError();
                })
                .catch(function (error) {});
        },
        getListColors() {
            let me = this;
            axios
                .get("/api/sections/colors")
                .then(function (response) {
                    me.arrayColors = response.data;
                })
                .catch(function (error) {});
        },
        update() {
            let me = this;
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;
            if (me.validForm()) {
                axios
                    .put(`/api/sections?section=privacidad&key=${authUserId}`, {
                        image: me.image,
                        image_webp: me.image_webp,
                        title: me.title,
                        text_image_alt: me.text_image_alt,
                        color_id: me.color ? me.color.id : null,
                    })
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.image_webp_path = response.data.image_webp_path;
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo título es obligatorio."];
                valid = false;
            } else if (me.title.length > 100) {
                me.allerrors.title = [
                    "El campo título debe tener máximo 100 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = [""];
            }

            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (!me.color) {
                me.allerrors.color_id = ["El campo color es obligatorio."];
                valid = false;
            } else {
                me.allerrors.color_id = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
                color_id: null,
            };
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        me.getModel();
        me.getListColors();
        new qq.FineUploader({
            element: document.getElementById("fine-uploader-manual-trigger"),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger",
            validation: {
                allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image"] = null;
                        me.image = response.path;
                    } else {
                        me.allerrors["image"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });
        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-webp"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-webp",
            validation: {
                allowedExtensions: ["webp"],
                sizeLimit: 20971520,
                image: {
                    maxHeight: 683,
                    minHeight: 683,
                    maxWidth: 1440,
                    minWidth: 1440,
                },
            },
            messages: {
                noFilesError: "Seleccione una imagen de tipo webp.",
                maxWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x683 px.",
                minWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x683 px.",
                maxHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x683 px.",
                minHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x683 px.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_webp"] = null;
                        me.image_webp = response.path;
                    } else {
                        me.allerrors["image_webp"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
